// API Configuration
// Centralized API base URL configuration

const API_ENDPOINTS = {
  // Supplier Management
  // Note: axios instances already have baseURL: '/api', so paths should not include /api prefix
  SUPPLIERS: () => '/suppliers/',
  SUPPLIERS_SUBCATEGORIES: () => '/suppliers/subcategories',
  SUPPLIERS_MAPPINGS: (limit = 100) => `/suppliers/mappings?limit=${limit}`,
  SUPPLIERS_MAPPINGS_CREATE: () => '/suppliers/mappings',

  // Category Management
  CATEGORIES: () => '/categories/',
  SUBCATEGORIES: () => '/subcategories/',

  // Master Products
  MASTER_PRODUCTS: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.supplier_id) params.append('supplier_id', filters.supplier_id);
    if (filters.subcategory_id) params.append('subcategory_id', filters.subcategory_id);
    if (filters.is_active !== undefined) params.append('is_active', filters.is_active);
    const queryString = params.toString();
    return `/master-products/products${queryString ? '?' + queryString : ''}`;
  },

  // Add other endpoints as needed
  TRANSACTIONS: () => '/transactions/',
  PAYMENT_METHODS: () => '/payment-methods/',
  DASHBOARD: () => '/dashboard/',
};

export default API_ENDPOINTS;